import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { GUIAS } from '../../conteudo/guias';
import base from './publico.module.css';
import css from './Secoes.module.css';

/**
 * Perguntas frequentes.
 *
 * As QUATRO primeiras são as MESMAS do FAQPage marcado no index.html. Marcação
 * estruturada que promete resposta ausente da página é motivo de penalização
 * manual — as duas têm que andar juntas. As demais são só da página (a página
 * pode ter mais do que a marcação; o contrário é que não pode).
 */
export function Duvidas() {
  return (
    <section id="duvidas" className={`${base.secao} ${base.secaoSuave}`}>
      <div className={`${base.conteudo} ${css.duvidasGrade}`}>
        <div className={css.duvidasAbertura}>
          <span className={base.sobretitulo}>Dúvidas frequentes</span>
          <h2 className={base.titulo}>O que costumam perguntar</h2>
          <p className={css.paragrafo}>
            Não achou a sua? Dentro do painel há um chat de suporte, respondido
            por quem cuida do serviço.
          </p>
          <div className={css.guiasLista}>
            <span>Guias</span>
            {GUIAS.map((g) => (
              <Link key={g.rota} to={g.rota} data-clique="guia-duvidas">
                {g.h1}
              </Link>
            ))}
          </div>
        </div>

        <div className={css.acordeao}>
          <Duvida aberta pergunta="Preciso de certificado digital para baixar o XML?">
            Não. Não exigimos certificado A1 nem procuração eletrônica no
            e-CAC. Basta a chave de acesso da nota — digitada, enviada em CSV
            ou extraída do seu arquivo SPED. O certificado só entra se você
            optar pela captura automática das notas de entrada.
          </Duvida>
          <Duvida pergunta="Como baixar o XML de várias notas de uma vez?">
            Envie o SPED (EFD ICMS/IPI ou EFD Contribuições), inclusive a
            pasta do ano inteiro em .zip, e extraímos as chaves de todas as
            notas. Você filtra por competência, CFOP ou situação e baixa tudo
            num único ZIP. Também dá para colar a lista ou enviar um CSV.
          </Duvida>
          <Duvida pergunta="Para que serve o XML na apuração?">
            O DANFE em PDF é só a representação da nota. Base de cálculo,
            alíquota, CST, CFOP e valor por item existem apenas no XML — é
            dele que saem a apuração de ICMS, IPI, PIS e COFINS, a conferência
            de créditos e a resposta a uma fiscalização. A legislação também
            exige a guarda do arquivo digital pelo prazo decadencial de cinco
            anos.
          </Duvida>
          <Duvida pergunta="Quanto custa?">
            Você paga por XML entregue, sem mensalidade e sem fidelidade. O
            preço cai conforme o volume, chegando a R$ 0,03 por XML. Enviar e
            analisar o SPED é gratuito, e nota que não for encontrada não é
            cobrada: o valor volta para o seu saldo. A captura automática pelo
            certificado A1 é opcional e tem plano mensal à parte, pela
            quantidade de CNPJs.
          </Duvida>
          <Duvida pergunta="O que acontece com a chave que não for encontrada?">
            Ela aparece separada no resultado, como não encontrada na fonte, e
            não é cobrada: o valor do lote fica reservado e, no fim, a
            diferença do que não foi entregue volta para o seu saldo.
          </Duvida>
          <Duvida pergunta="Como funciona o pagamento?">
            Por Pix: você gera o QR Code no painel e o crédito entra
            automaticamente na confirmação. A cobrança é emitida pelo Asaas;
            não recebemos nem armazenamos dados de cartão.
          </Duvida>
          <Duvida pergunta="Por quanto tempo os arquivos ficam disponíveis?">
            As buscas e os arquivos são removidos automaticamente 48 horas após
            a conclusão. Baixe o ZIP antes disso — depois, não temos como
            recuperá-lo.
          </Duvida>
        </div>
      </div>
    </section>
  );
}

/**
 * Uma pergunta do FAQ. `<details>` nativo: abre e fecha sem JavaScript, e o
 * conteúdo fica no HTML mesmo fechado — o buscador lê a resposta de qualquer
 * jeito, ao contrário de um acordeão que só monta o texto ao clicar.
 */
function Duvida({
  pergunta,
  aberta,
  children,
}: {
  pergunta: string;
  aberta?: boolean;
  children: ReactNode;
}) {
  return (
    <details className={css.duvida} open={aberta}>
      <summary>
        <span>{pergunta}</span>
        <ChevronDown aria-hidden="true" />
      </summary>
      <p>{children}</p>
    </details>
  );
}
